import { axiosInstance, requestConfig } from 'network/apis';

import { URL_SYSTEM } from "utils/constants";

export const callQnaList = async (data) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, '/qna', data));
};

export const callAddQnaQuestion = async (headers, data) => {
    return await axiosInstance(requestConfig('post', URL_SYSTEM, '/qna', data, headers));
};

export const callQnaInfo = async (idx) => {
    return await axiosInstance(requestConfig('get', URL_SYSTEM, `/qna/${idx}`));
};